import React, { useState, Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { Search } from 'semantic-ui-react';
import i18next from 'i18next';

import './SearchAddress.scss';
import paiditApi from '../../api/paidit-api';

const isValidAddress = (address) => {
    if (address.types.includes('establishment') || address.types.includes('point_of_interest')) {
        return true;
    } else {
        return /\d/.test(address.title);
    }
};

const SearchAddress = (props) => {
    const [errorVisibe, setErrorVisibility] = useState(false);
    const [predictions, setPredictions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);

    return (
        <Fragment>
            <Search
                className="pi address"
                placeholder={i18next.t('order.address.searchAddress')}
                loading={loading || props.isLoading}
                minCharacters={2}
                open={showResults}
                noResultsMessage={i18next.t('order.address.notFound')}
                onResultSelect={async (e, { result: address }) => {
                    setShowResults(false);
                    
                    if (!isValidAddress(address)) {
                        setErrorVisibility(true);
                    } else {
                        setErrorVisibility(false);

                        const { result } = await paiditApi({ trackLoading: true, rejectOnError: false }).google.locationDetails(address.value, i18next.language);
              
                        props.onAddressChanged(result);
                    }
                }}
                onSearchChange={async (e, { value }) => {
                    setShowResults(true);
                    setLoading(true);
                    
                    // TODO: debounce
                    const { predictions } = await paiditApi({ trackLoading: false, rejectOnError: false }).google.locationAutocomplete(value, i18next.language) || { predictions: [] };

                    setLoading(false);

                    setPredictions(predictions.map(p => ({ value: p.place_id, title: p.description, types: p.types })));
                }}
                results={predictions}
            />
            {errorVisibe && <span className="address-error">{i18next.t('order.address.fillHouseNumber')}</span>}
        </Fragment>
    );
};

SearchAddress.propTypes = {
    onAddressChanged: PropTypes.func,
    isLoading: PropTypes.bool
};

export default memo(SearchAddress);